// Visuels Eternua : accueil et Aujourd’hui. Images seules, sans changement de comportement.
export const RUBRIC_IMAGES = {
  "acheter": {
    "src": "/images/rubriques/acheter.webp",
    "file": "images/acheter.webp",
    "alt": "Une personne choisit des objets sur un marché chaleureux.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 202420,
    "sha256": "04408d558d6cd8d714304230f6fe431b3e5e78cabd027fe0b3c5dce225470144"
  },
  "relation-acheter-vendre": {
    "src": "/images/rubriques/relation-acheter-vendre.webp",
    "file": "images/relation-acheter-vendre.webp",
    "alt": "Deux personnes échangent un colis.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 183716,
    "sha256": "2ac37dc199075f795d78f354de4f02524a9ebb68cb6337952c01606276523ecd"
  },
  "carte-vivante": {
    "src": "/images/rubriques/carte-vivante.webp",
    "file": "images/carte-vivante.webp",
    "alt": "Maquette d’un quartier avec des repères géographiques lumineux.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 256616,
    "sha256": "e4861032d5cb7ec14a3149d20612017427f46ed55b2a8fa3fcc312da13baed71"
  },
  "vendre": {
    "src": "/images/rubriques/vendre.webp",
    "file": "images/vendre.webp",
    "alt": "Une personne photographie un objet pour préparer une annonce.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 153954,
    "sha256": "0f9685ff0b20d98b7fdf5082c08e3cdb317d83bdb76cec8c0ac99d1e4c708a4f"
  },
  "encheres": {
    "src": "/images/rubriques/encheres.webp",
    "file": "images/encheres.webp",
    "alt": "Marteau de vente aux enchères et objets de collection.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 183248,
    "sha256": "c12431d1a6142bda9f5f71985b99f69da3b84740a9f2dfc1a956b882502ba52c"
  },
  "ventes-flash": {
    "src": "/images/rubriques/ventes-flash.webp",
    "file": "images/ventes-flash.webp",
    "alt": "Objets proposés à la vente avec une horloge symbolique.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 185336,
    "sha256": "d94d7f3f8edcb1df6a5a5ac9bd454b1855e59acac9a0f1a94247b13cb175d7d7"
  },
  "emploi": {
    "src": "/images/rubriques/emploi.webp",
    "file": "images/emploi.webp",
    "alt": "Deux personnes échangent lors d’un entretien professionnel.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 103106,
    "sha256": "8d88d32855d26c03ea0bd3e45945a32356f2d9db4eeb183f737f184adc53c806"
  },
  "candidature-emploi": {
    "src": "/images/rubriques/candidature-emploi.webp",
    "file": "images/candidature-emploi.webp",
    "alt": "Une personne prépare son dossier de candidature.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 121226,
    "sha256": "c28e66d1d3983887938c956078f3f8bebc0ea702d2f0baacf14ca7655eb4c209"
  },
  "services": {
    "src": "/images/rubriques/services.webp",
    "file": "images/services.webp",
    "alt": "Un artisan et son client discutent dans un atelier.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 197362,
    "sha256": "5ab8b93768c13f2b5ae93dad29ccd4fd13b825115279372efc4f41d8251847ca"
  },
  "rapprochement-filtres": {
    "src": "/images/rubriques/rapprochement-filtres.webp",
    "file": "images/rapprochement-filtres.webp",
    "alt": "Des cadres transparents organisent une sélection d’objets.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 108824,
    "sha256": "3b02aaf0c6880810485cf807801dc62612f19c03484fab1feb0fec063194cffa"
  },
  "suivi-services": {
    "src": "/images/rubriques/suivi-services.webp",
    "file": "images/suivi-services.webp",
    "alt": "Deux personnes préparent les étapes d’une prestation.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 235178,
    "sha256": "1520c1228e8427c92c0854af9efa6910a6b3a24eb0d632614538ad165f7fa36f"
  },
  "forum": {
    "src": "/images/rubriques/forum.webp",
    "file": "images/forum.webp",
    "alt": "Un groupe échange des idées autour d’une table.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 196730,
    "sha256": "5df13ca23840e47ea6c0ebe4c7fee931f02611c204252be60fd353480e506f6d"
  },
  "sorties": {
    "src": "/images/rubriques/sorties.webp",
    "file": "images/sorties.webp",
    "alt": "Des amis profitent d’une sortie culturelle en ville.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 207572,
    "sha256": "5b7947a0b1fb4dc4593662650324a22de05affc127d3bc7ed6bfd25dcbb1bae1"
  },
  "voyage": {
    "src": "/images/rubriques/voyage.webp",
    "file": "images/voyage.webp",
    "alt": "Paysage méditerranéen et bagage de voyage.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 347786,
    "sha256": "e7a718d880b558c13bf2731ab5471a7a6597e7e14af7e008af87d5b949ab3d1b"
  },
  "sport-loisirs": {
    "src": "/images/rubriques/sport-loisirs.webp",
    "file": "images/sport-loisirs.webp",
    "alt": "Des adultes pratiquent le badminton dans un parc.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 318234,
    "sha256": "024719dd97762397fc9e274373aa59ce4e136b143e552f74e19fa9ffa84c5a8b"
  },
  "babysitting": {
    "src": "/images/rubriques/babysitting.webp",
    "file": "images/babysitting.webp",
    "alt": "Un adulte accompagne un enfant pendant une lecture.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 201228,
    "sha256": "13cca480b1e8cf1da36b1a8d76c39b3e2f97167639b1eef58e1aa57d2cafa299"
  },
  "immobilier-sejours": {
    "src": "/images/rubriques/immobilier-sejours.webp",
    "file": "images/immobilier-sejours.webp",
    "alt": "Maison méditerranéenne et clés, illustration immobilière.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 352536,
    "sha256": "746246330394d053178d2b4feee0da70b826a0eafabc8ba4a5fe4385c6eaf012"
  },
  "financement-participatif": {
    "src": "/images/rubriques/financement-participatif.webp",
    "file": "images/financement-participatif.webp",
    "alt": "Des personnes réunies autour de la maquette d’un projet collectif.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 258790,
    "sha256": "c1c32f922c986351b0d861056d9aac17a2cd5fcef7660ab621cc8233e3e2c26a"
  },
  "animaux": {
    "src": "/images/rubriques/animaux.webp",
    "file": "images/animaux.webp",
    "alt": "Une personne avec un chien et un chat dans un jardin.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 237716,
    "sha256": "740042b32ccd1c6d30b3053bb16fc19343402faf7245bf74e498e9c02abcc956"
  },
  "messagerie": {
    "src": "/images/rubriques/messagerie.webp",
    "file": "images/messagerie.webp",
    "alt": "Deux personnes communiquent à distance avec leur téléphone.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 167022,
    "sha256": "f0e62b4b5dd9aa6c91c671388d36eb24bdc0b89381c7320430c59d0bd6c8014e"
  },
  "portefeuille": {
    "src": "/images/rubriques/portefeuille.webp",
    "file": "images/portefeuille.webp",
    "alt": "Portefeuille bleu et étoiles représentant des points internes.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 158738,
    "sha256": "141b805bceb75f2663d7182f0ad8ad32e14dbb3f1759232954f9a2be19ee3685"
  },
  "premium": {
    "src": "/images/rubriques/premium.webp",
    "file": "images/premium.webp",
    "alt": "Symbole de l’infini en verre et métal avec une invitation sans inscription.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 218750,
    "sha256": "16b2166208b78936363faa7c5974a1258cba68db0299ed2c2c95a24bc6945948"
  },
  "meteo": {
    "src": "/images/rubriques/meteo.webp",
    "file": "images/meteo.webp",
    "alt": "Paysage, soleil et nuages illustrant la météo.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 470196,
    "sha256": "2f4397d522eadb71619f894e19af7d01f272ea338015ca4ce7f862974bc01d2f"
  },
  "mon-parcours": {
    "src": "/images/rubriques/mon-parcours.webp",
    "file": "images/mon-parcours.webp",
    "alt": "Une personne avance sur un chemin dans un jardin.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 455286,
    "sha256": "8960406edfdfc636a437f2efdf8f3e785ff1f62c8c7b73e6541c96c7f2b09736"
  },
  "studio-lia": {
    "src": "/images/rubriques/studio-lia.webp",
    "file": "images/studio-lia.webp",
    "alt": "Une personne travaille sur un projet créatif dans un atelier.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 227640,
    "sha256": "653f0734833992cc53f5fffc3fed739bd9ec378d4c307d576719379176733c4b"
  },
  "centre-protection": {
    "src": "/images/rubriques/centre-protection.webp",
    "file": "images/centre-protection.webp",
    "alt": "Un médiateur accompagne deux personnes, avec un bouclier symbolique.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 215560,
    "sha256": "6bfb0a62c1ddda581ee7bd9fdde45cc9c8e6a07251b15d77bfdee55605779dc4"
  },
  "recherche": {
    "src": "/images/rubriques/recherche.webp",
    "file": "images/recherche.webp",
    "alt": "Loupe, fiches vierges et objets de bibliothèque.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 194016,
    "sha256": "3eaad2ee60158655e55387bed24376210d5d688619c92fcda357dd3c2f3df0f4"
  },
  "agenda": {
    "src": "/images/rubriques/agenda.webp",
    "file": "images/agenda.webp",
    "alt": "Calendrier sans inscriptions et accessoires d’organisation.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 132672,
    "sha256": "7417f58c1e3b9c8a14767ed16fbdd1aec318007a033d680f02934e344ad467c0"
  },
  "cercles-du-jour": {
    "src": "/images/rubriques/cercles-du-jour.webp",
    "file": "images/cercles-du-jour.webp",
    "alt": "Des adultes participent à une discussion autour d’une table.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 181852,
    "sha256": "502abbde742f96e88bec80b0ae7db8012ba2eeb3aa35aad5d9b2776fb7f61467"
  },
  "coffre-documentaire": {
    "src": "/images/rubriques/coffre-documentaire.webp",
    "file": "images/coffre-documentaire.webp",
    "alt": "Coffre fermé et dossiers documentaires.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 120286,
    "sha256": "3c4b79dec244447af1fc055ac5ac0f734cd2e1cab395b3a406a93c62cf294b79"
  },
  "mon-infini": {
    "src": "/images/rubriques/mon-infini.webp",
    "file": "images/mon-infini.webp",
    "alt": "Carnet de souvenirs privé et constellation symbolique.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 164618,
    "sha256": "2db04bebdeba184f3f3232252423f74ffbd805428466c6571472cfc1449c4038"
  },
  "paiements-marketplace": {
    "src": "/images/rubriques/paiements-marketplace.webp",
    "file": "images/paiements-marketplace.webp",
    "alt": "Terminal de paiement éteint sur un comptoir, illustration conceptuelle.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 121598,
    "sha256": "88aab256c008e64679a8ae32c0506137cc2c52e7efd0e47bf6e7577e7c57bb7d"
  },
  "notifications": {
    "src": "/images/rubriques/notifications.webp",
    "file": "images/notifications.webp",
    "alt": "Cloche en verre et enveloppes symbolisant les notifications.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 166384,
    "sha256": "ca970c042ac0935769d89989db5571d729d34367cfa0472231aee36183e77c93"
  },
  "reglement-prestations": {
    "src": "/images/rubriques/reglement-prestations.webp",
    "file": "images/reglement-prestations.webp",
    "alt": "Deux personnes examinent le dossier d’une prestation.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 163594,
    "sha256": "4f7d60fcaa3bd4954148b62db7a5d85c0feb29811ab48038c81321f91dfbe2eb"
  },
  "communaute": {
    "src": "/images/rubriques/communaute.webp",
    "file": "images/communaute.webp",
    "alt": "Des adultes participent à un jardin partagé.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 319308,
    "sha256": "66f2762629acbc653754f7eb96a6ae6ae4b0671ad5de2f35400647cd05ef74c8"
  },
  "recompenses": {
    "src": "/images/rubriques/recompenses.webp",
    "file": "images/recompenses.webp",
    "alt": "Trophée doré et étoiles en cristal.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 183456,
    "sha256": "b2f5713d4a1f08c30947137aa550375548e788e9fe4790ad22229166550392e5"
  },
  "amis": {
    "src": "/images/rubriques/amis.webp",
    "file": "images/amis.webp",
    "alt": "Deux amis discutent sur un banc dans un jardin.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 323628,
    "sha256": "4056db459ead9dfff8c5f266c51a0602c92d6d49931b10760c6b2e15dab8a4b6"
  },
  "entraide": {
    "src": "/images/rubriques/entraide.webp",
    "file": "images/entraide.webp",
    "alt": "Des voisins s’entraident et se prêtent un outil dans un jardin.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 274214,
    "sha256": "a0d13521ad1201e4be3045c40a3e466d913ff3e540edb5f1ada56ff0ea59032a"
  },
  "vision-france-3024": {
    "src": "/images/rubriques/vision-france-3024.webp",
    "file": "images/vision-france-3024.webp",
    "alt": "Vision imaginaire d’une ville française végétalisée du futur.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 486372,
    "sha256": "df3962d1d2310d8bbf630b65b582ced5a6279717ba5da95dee164400882035ec"
  },
  "vision-human-ai": {
    "src": "/images/rubriques/vision-human-ai.webp",
    "file": "images/vision-human-ai.webp",
    "alt": "Assemblée imaginaire de figures humaines et numériques.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 293616,
    "sha256": "391cf3feaf881455a5b5c7cb7b12c0f2e70397596eb7c0c8878d891b15cf9afb"
  },
  "vision-lia-evolution": {
    "src": "/images/rubriques/vision-lia-evolution.webp",
    "file": "images/vision-lia-evolution.webp",
    "alt": "Personnage numérique féminin illustrant une évolution possible de LIA.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 256216,
    "sha256": "1570ea35ae468db12b576c3485a9e0f1e531fc590323e9ddd889f0604204b926"
  },
  "vision-et-civilizations": {
    "src": "/images/rubriques/vision-et-civilizations.webp",
    "file": "images/vision-et-civilizations.webp",
    "alt": "Cité extraterrestre imaginaire, illustration de fiction.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 358284,
    "sha256": "284fbfb086a62972a18f2be58cca1d31628faaf4cf2cd04976d42c3ff84c8f13"
  },
  "vision-eternal-health": {
    "src": "/images/rubriques/vision-eternal-health.webp",
    "file": "images/vision-eternal-health.webp",
    "alt": "Recherche cellulaire imaginée dans un laboratoire futuriste.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 167374,
    "sha256": "a2b6ef46a6123f7dcaa172578cea22d2001250d07c1b2783884ad9add80bd320"
  },
  "vision-temples": {
    "src": "/images/rubriques/vision-temples.webp",
    "file": "images/vision-temples.webp",
    "alt": "Architecture contemplative imaginaire avec des arches lumineuses.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 334020,
    "sha256": "3d55e0d1a29325c0ed7e703263a52c4a9b4a121f4840c49360cd683cae44b777"
  },
  "vision-infrastructures": {
    "src": "/images/rubriques/vision-infrastructures.webp",
    "file": "images/vision-infrastructures.webp",
    "alt": "Centre de données futuriste imaginé.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 262724,
    "sha256": "76cb7f16cef0bc19f22921357089d7a8abc6af6e34fdbdc85af38c7c9d2731b1"
  },
  "vision-dossiers": {
    "src": "/images/rubriques/vision-dossiers.webp",
    "file": "images/vision-dossiers.webp",
    "alt": "Bibliothèque et tomes prospectifs ouverts sans inscriptions.",
    "width": 1672,
    "height": 941,
    "format": "webp",
    "bytes": 183906,
    "sha256": "f4b9e018c5c79edd14f3ca871cdab8f4a70825f5e7361b5c61af3b069fd04eec"
  }
};

export const IMAGE_SLUG_BY_FEATURE = {
  "today-buy": "acheter",
  "today-sell": "vendre",
  "today-employment": "emploi",
  "today-services": "services",
  "today-outings": "sorties",
  "today-travel": "voyage",
  "today-crowdfunding": "financement-participatif",
  "today-rewards": "recompenses",
  "today-forum": "forum",
  "today-friends": "amis",
  "today-live-map": "carte-vivante",
  "today-auctions": "encheres",
  "today-flash-sales": "ventes-flash",
  "today-mutual-aid": "entraide",
  "today-sport": "sport-loisirs",
  "today-babysitting": "babysitting",
  "today-real-estate": "immobilier-sejours",
  "today-animals": "animaux",
  "today-chat": "messagerie",
  "today-wallet": "portefeuille",
  "today-subscriptions": "premium",
  "today-weather": "meteo",
  "today-guided-journeys": "mon-parcours",
  "today-studio": "studio-lia",
  "today-protection": "centre-protection",
  "today-global-search": "recherche",
  "today-agenda": "agenda",
  "today-daily-circles": "cercles-du-jour",
  "marketplace-contact-followup": "relation-acheter-vendre",
  "marketplace-secure-payment": "paiements-marketplace",
  "notification-center": "notifications",
  "employment-internal-application": "candidature-emploi",
  "deterministic-filter-matching": "rapprochement-filtres",
  "services-quotes-followup": "suivi-services",
  "services-payment": "reglement-prestations",
  "today-document-vault": "coffre-documentaire",
  "today-community": "communaute",
  "infini-infini": "mon-infini",
  "vision-france-3024": "vision-france-3024",
  "vision-human-ai": "vision-human-ai",
  "vision-lia-evolution": "vision-lia-evolution",
  "vision-et-civilizations": "vision-et-civilizations",
  "vision-eternal-health": "vision-eternal-health",
  "vision-temples": "vision-temples",
  "vision-infrastructures": "vision-infrastructures",
  "vision-dossiers": "vision-dossiers"
};

export const TODAY_IMAGE_SLUG_BY_TITLE = {
  "Acheter et gérer son panier": "acheter",
  "Mise en relation Acheter / Vendre": "relation-acheter-vendre",
  "Carte vivante": "carte-vivante",
  "Vendre et piloter ses annonces": "vendre",
  "Enchères": "encheres",
  "Ventes flash": "ventes-flash",
  "Emploi": "emploi",
  "Candidature Emploi interne": "candidature-emploi",
  "Services": "services",
  "Rapprochement par filtres": "rapprochement-filtres",
  "Propositions et suivi Services": "suivi-services",
  "Forum": "forum",
  "Sorties": "sorties",
  "Voyage": "voyage",
  "Sport & loisirs": "sport-loisirs",
  "Babysitting": "babysitting",
  "Immobilier & séjours": "immobilier-sejours",
  "Financement participatif": "financement-participatif",
  "Animaux": "animaux",
  "Messagerie": "messagerie",
  "Portefeuille Eternua": "portefeuille",
  "Eternua Premium": "premium",
  "Météo": "meteo",
  "Mon Parcours": "mon-parcours",
  "Studio LIA": "studio-lia",
  "Centre Protection": "centre-protection",
  "Recherche générale": "recherche",
  "Agenda": "agenda",
  "Cercles du jour": "cercles-du-jour",
  "Coffre documentaire": "coffre-documentaire",
  "Mon Infini": "mon-infini",
  "Paiements Marketplace": "paiements-marketplace",
  "Centre de notifications": "notifications",
  "Règlement de prestations": "reglement-prestations",
  "Communauté": "communaute"
};

export function imageForFeature(feature) {
  const key = typeof feature === "string" ? feature : feature?.featureKey;
  return RUBRIC_IMAGES[IMAGE_SLUG_BY_FEATURE[key]] ?? null;
}

export function imageForTodayCard(title) {
  return RUBRIC_IMAGES[TODAY_IMAGE_SLUG_BY_TITLE[title]] ?? null;
}
